import SectionHead from './SectionHead';
import { materialTypes, materialItems } from '../data';

const typeBadge: Record<string, { chip: string; icon: string }> = {
  chat: { chip: 'bg-primary-100 text-primary-800', icon: 'ri-chat-3-line' },
  shot: { chip: 'bg-accent-100 text-accent-900', icon: 'ri-camera-line' },
  clue: { chip: 'bg-secondary-100 text-secondary-900', icon: 'ri-focus-3-line' },
};

const typeName: Record<string, string> = {
  chat: '聊天记录',
  shot: '截图留痕',
  clue: '线索旁证',
};

export default function ArchiveSection() {
  return (
    <section id="archive" className="scroll-mt-20 bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-10 md:py-16">
        <SectionHead
          eyebrow="素材库 · 分门别类"
          title="聊天记录、截图与线索，按类型归档"
          desc="每一类素材都带独立编号体系与收录说明，检索时先定类型、再对编号，细节不遗漏。"
        />

        {/* 类型入口 */}
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {materialTypes.map((t, i) => (
            <a
              key={t.key}
              href="#archive"
              className={`group flex flex-col rounded-xl border p-5 md:p-6 transition-colors ${
                i === 1
                  ? 'border-accent-200 bg-background-50 hover:border-accent-300'
                  : 'border-background-200 bg-background-50 hover:border-primary-300'
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                    i === 1 ? 'bg-accent-100 text-accent-900' : 'bg-primary-100 text-primary-800'
                  }`}
                >
                  <i className={`${t.icon} w-5 h-5 flex items-center justify-center`} />
                </span>
                <span className="font-heading text-lg font-bold text-foreground-950">{t.total}</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{t.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-secondary-700">
                查看该类型
                <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center transition-transform group-hover:translate-x-1" />
              </span>
            </a>
          ))}
        </div>

        {/* 素材清单 */}
        <div className="mt-6 flex flex-wrap items-center gap-2">
          <span className="text-xs text-foreground-500">快捷筛选：</span>
          {['全部', ...materialTypes.map((t) => t.name)].map((f, i) => (
            <button
              key={f}
              type="button"
              className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ${
                i === 0
                  ? 'bg-primary-600 text-background-50'
                  : 'border border-background-300 bg-background-50 text-foreground-700 hover:bg-background-100'
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {materialItems.map((m) => {
            const b = typeBadge[m.type];
            return (
              <article
                key={m.no}
                className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <div className="flex items-center justify-between gap-2">
                  <span className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-[11px] font-medium ${b.chip}`}>
                    <i className={`${b.icon} w-3 h-3 flex items-center justify-center`} />
                    {typeName[m.type]}
                  </span>
                  <span className="font-label text-[11px] font-semibold tracking-wide text-foreground-400">{m.no}</span>
                </div>
                <h4 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">{m.name}</h4>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{m.note}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-[11px] font-medium text-secondary-700">
                  <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center" />
                  {m.meta}
                </span>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}